var _path, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon18(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 77,
    viewBox: "0 0 72 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M58.3613 17.0311H23.7561C21.547 17.0311 19.7561 18.822 19.7561 21.0311V72.64C19.7561 74.8491 21.547 76.64 23.7561 76.64H44.709C46.9181 76.64 48.709 74.8491 48.709 72.64V70.4213C48.709 68.2122 50.4998 66.4213 52.709 66.4213H60.7182C62.9274 66.4213 64.7182 64.6305 64.7182 62.4213V53.2076C64.7182 52.228 65.5123 51.434 66.4918 51.434C69.0384 51.434 70.7554 48.8301 69.7522 46.4895L65.0417 35.4981C64.8283 35.0002 64.7182 34.4642 64.7182 33.9225V26.3878C64.7182 25.8331 64.6029 25.2845 64.3795 24.7768L62.0226 19.4202C61.3838 17.9683 59.9475 17.0311 58.3613 17.0311Z",
    fill: "#4992FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 39.5122,
    height: 38.8309,
    rx: 5,
    fill: "#55D6FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 46.3246,
    width: 7.49369,
    height: 6.81244,
    fill: "#FF7A41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon18);
export default __webpack_public_path__ + "static/media/icon_18.fb9ff37d3357e1c73c8d12157677e8db.svg";
export { ForwardRef as ReactComponent };